<div
    class="py-3"
    [formGroup]="form()">
    <div class="mb-4">
        <program-selection-list
            [programs]="programs()"
            [formGroup]="form()"
            required="true"
            id="program" />
    </div>

    <div class="mb-4">
        <text-input
            [formGroup]="form()"
            id="capNumber"
            [maxLength]="128"
            label="Project CAP#" />
    </div>

    <div class="mb-4">
        <text-input
            [formGroup]="form()"
            id="name"
            required="true"
            focus="true"
            [maxLength]="128"
            label="Project Short Name" />

        <name-validation-errors
            [formGroup]="form()"
            id="name"
            label="Project Short Name" />
    </div>

    <div class="mb-4">
        <label
            for="spaFile"
            role="button"
            class="spa-field border-form-control primary-bg-100 rounded position-relative d-block">
            <span class="position-absolute primary-bg-100 primary-text-200 px-1 font-4 form-label">
                Upload SPA
            </span>

            <div class="row g-0 p-3 align-items-center">
                @if (project().spaFile(); as spaFile) {
                    <span class="col primary-text text-truncate">
                        {{ spaFile.name }}
                    </span>
                } @else {
                    @if (project().existingSpa(); as existingSpa) {
                        <span class="col primary-text text-truncate">
                            {{ existingSpa.name }}
                        </span>
                    } @else {
                        <span class="col primary-text text-truncate"></span>
                    }
                }
                <span class="col-auto">
                    <svg-icon key="upload"></svg-icon>
                </span>
            </div>
        </label>

        <input
            id="spaFile"
            type="file"
            accept=".xlsx,.xls,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
            class="d-none"
            (change)="onSpaFileSelected($event)" />
    </div>
</div>
